import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HistoryEntry from '../../../case/history/HistoryEntry';
import * as docketActions from '../../../../redux/actions/docketActions';
import '../../../case/docket/Docket.less';

const EventsResultRow = ({ row, id, getDocuments, selectedDocket }) => {
  const onGetDocuments = (docket, court_code, case_number) => {
    getDocuments({
      docket_no: docket.docket_no,
      docket_seq: docket.docket_seq,
      court_code,
      case_number,
    });
  };

  return (
    <table className="ir-search-table-results sticky-enabled docket">
      <tbody>
        <HistoryEntry
          id={`docket-entry-${id}`}
          key={`docket-entry-${id}`}
          docket={row}
          redact={{}}
          showRedactPopup={() => {}}
          case_uuid=""
          court_code={row.case_court}
          case_number={row.case_no}
          onGetDocuments={onGetDocuments}
          selectedDocket={selectedDocket}
        />
      </tbody>
    </table>
  );
};

EventsResultRow.propTypes = {
  row: PropTypes.any.isRequired,
  id: PropTypes.any.isRequired,
  selectedDocket: PropTypes.any.isRequired,
  getDocuments: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selectedDocket: state.getIn(['dockets', 'selectedDocket']).toJS(),
});

const mapDispatchToProps = {
  getDocuments: docketActions.getDocuments,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsResultRow);



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/EventsResultRow.jsx